(function () {
  'use strict';

  /* @ngdoc object
   * @name payment
   * @description
   *
   */
  angular
    .module('flightReports', [
      'ui.router','voyageReport','cabinFlightAdmin'
    ]);
}());
